









































// @ is an alias to /src
import {Vue, Component, Ref} from "vue-property-decorator";
import axios from 'axios';
import SegmentSources from "@/components/SegmentSources.vue";
import CreateSegment from "@/components/CreateSegment.vue";
import {AxiosResponse} from 'axios';
import {
    Pixel as SSPixel,
    Event as SSEvent,
    Category as SSCategory,
    Segment as SSSegment,
} from '@/components/SegmentSources'
import {LoadSegmentSources} from "@/components/LoadSegmentSources";

type StatsResponse = {
    stats: Array<Stat>
}

type Stat = {
    date: string,
    count: number,
    new: number,
    unique: number
}

type Category = {
    id: string,
    name: string,
    size: number,
    created_at: string,
}

type SegmentWithSources = {
    id: string,
    name: string,
    relative_sources: Array<RelativeSource>,
    event_sources: Array<EventSource>,
}

type RelativeSource = {
    relative_id: string,
    type: string,
}

type EventSource = {
    event_id: string,
    key: string,
    value_type: string,
    value: string,
    type: string,
}

type CategoriesModel = {
    headers: any
    data: Array<Category>
    loading: boolean
}

type CategoriesResponse = {
    categories: Array<Category>
}

type CategoriesStatResponse = {
    stats: Array<Category>
}

@Component({
    components: {
        CreateSegment
    }
})
export default class Categories extends Vue {
    private events_source: Array<SSEvent> = []
    private pixels_source: Array<SSPixel> = []
    private segments_source: Array<SSSegment> = []
    private categories_source: Array<SSCategory> = []

    private create_dialog: Boolean = false

    @Ref('union') unionSource !: SegmentSources
    @Ref('diff') diffSource !: SegmentSources
    @Ref('inter') interSource !: SegmentSources
    @Ref('create_name') createName !: any

    private categories: CategoriesModel = {
        headers: [
            {
                text: "ID",
                value: "id"
            },
            {
                text: "Name",
                value: "name"
            },
            {
                text: "Size",
                value: "size"
            },
            {
                text: "Created",
                value: "created_at"
            },
            {
                text: "Parent",
                value: "parent_name"
            },
            {
                text: "Actions",
                value: "actions",
                align: 'end',
                sortable: false,
            }
        ],
        data: [] as Array<Category>,
        loading: true,
    }

    mounted() {
        this.$store.dispatch('set_title', 'Categories')
        axios
            .get<CategoriesResponse>('/api/v1/categories')
            .then(response => {
                response.data.categories.forEach(function (obj) {
                    obj.size = obj.size || 0
                })
                this.categories.data = response.data.categories || []
                this.categories.loading = false
                this.update_stats()
            })
    }

    create_segment(obj: any) {
        axios
            .post<SegmentWithSources, AxiosResponse<Category>>(
                '/api/v1/categories', obj)
            .then(response => {
                response.data.size = response.data.size || 0
                this.categories.data.push(response.data)
                this.create_dialog = false
            })
    }

    update_stats() {
        let component = this
        axios
            .get<CategoriesStatResponse>(
                '/api/v1/segments/stat')
            .then(response => {
                response.data.stats.forEach(function (stat) {
                    let seg = component.categories.data.find(seg => seg.id == stat.id)
                    if (seg) {
                        seg.size = stat.size
                    }
                })
            })
    }

    openCreateSegmentDialog() {
        this.create_dialog = true
        let component = this
        LoadSegmentSources(function (sources: any) {
            component.pixels_source = sources.pixels
            component.events_source = sources.events
            component.categories_source = sources.categories
            component.segments_source = sources.segments
        })
    }

    exportCategory(item: Category) {
        axios
            .get<any>(
                '/api/v1/categories/' + item.id + '/users')
            .then(response => {
                this.downloadFile(item.name + '.csv', response.data)
            })
    }

    deleteCategory(item: Category) {
        axios
            .delete<any>(
                '/api/v1/categories/' + item.id)
            .then(() => {
                this.categories.data = this.categories.data.filter(it => it.id != item.id)
            })
    }

    downloadFile(name: string, data: any) {
        const url = window.URL.createObjectURL(new Blob([data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', name) //or any other extension
        document.body.appendChild(link)
        link.click()
    }
}
